import React from 'react';
import { type RouteContext, withRouter } from '@atlassian/react-resource-router';

type Props = RouteContext;

export const LegacyRouter = (props: Props) => {
	const { route } = props;

	if (!route || !route.component) {
		return null;
	}

	return <route.component {...props} />;
};

export default withRouter(LegacyRouter);
